export const getUniqueHash = () => Math.random().toString(36).slice(2, 11);
